// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const thievul: PokeData = {
  "id": 828,
  "name": "thievul",
  "height": 12,
  "weight": 199,
  "base_experience": 159,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "tail-whip",
    "quick-attack",
    "thief",
    "beat-up",
    "assurance",
    "sucker-punch",
    "night-slash",
    "nasty-plot",
    "hone-claws",
    "foul-play",
    "tail-slap",
    "snarl",
    "parting-shot"
  ],
  "moves": [
    "quick-attack",
    "night-slash",
    "snarl",
    "lash-out",
    "night-daze",
    "quash",
    "dark-bargain",
    "phantom-force",
    "flatter",
    "dark-pulse",
    "bite",
    "crunch",
    "pursuit"
  ],
  "evolution_chain": {
    "id": 436,
    "item": null,
    "species": [
      {
        "name": "nickit",
        "order": 827,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "thievul",
        "order": 828,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": 827,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 116,
    "speed": 144,
    "ability_power": 139
  },
  "stat_changes": [],
  "catch_rate": 127,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
